import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import * as formatters from '../../../utils/formatters';
import ActionButton from '../../elements/ActionButton';
import Search from '../../elements/Search';
import renderNumbers from '../../elements/lotteries/Numbers';
import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import TableHead from 'crm/elements/common/TableHead';
import { PERMISSION } from 'crm/helpers/Permissions';

function DrawsList({ url }) {
    const { slug } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [draws, setDraws] = useState([]);
    const [filter, setFilter] = useState('');
    const crmUrl = `/lotteries/${slug}/draws/`;

    const getDraws = (page = 1) => {
        let requestUrl = url;
        requestUrl += `?page=${page}`;
        axios.get(requestUrl, { params: { filter } }).then((response) => {
            setDraws(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    useEffect(() => {
        getDraws();
    }, [filter]);

    function getDrawsList() {
        const { formatDateStringWithTimezone } = formatters;
        return draws.map(({ id, draw_no, date, jackpot_formatted, numbers, type }) => (
            <tr key={id}>
                <td>
                    <ActionButton url={crmUrl + draw_no} title="open" permissions={[PERMISSION.VIEW_DRAW]} />
                </td>
                <td>{draw_no}</td>
                <td>{formatDateStringWithTimezone(date)}</td>
                <td>{jackpot_formatted}</td>
                <td>{renderNumbers(numbers, id, type)}</td>
            </tr>
        ));
    }
    return (
        <Card title="Draws">
            <Search filterTable={(value) => setFilter(value)} />
            <div className="table-responsive">
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <th>Draw number</th>
                        <th>Date</th>
                        <th>Jackpot</th>
                        <th>Draw numbers</th>
                    </TableHead>
                    <tbody>{getDrawsList()}</tbody>
                </table>
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getDraws} />
            </div>
        </Card>
    );
}

export default DrawsList;
